<template>
  <div>
    <h2 class="txt-head">
      จัดการส่วนงาน
    </h2>
    <v-divider
    class="mx-4"
    inset
    vertical
  ></v-divider>
    <v-layout class="row ml-10">
      <v-col cols="1">
        <p class="txt-font" style="margin-top: 1.5%;">ชื่อเครือ</p>
      </v-col>
      <v-col cols="4" class="mr-4">
        <v-select
          dense
          outlined
          :items="['INET', 'OGS']"
        ></v-select>
      </v-col>
    </v-layout>
    <v-layout class="row">
      <v-col cols="2">
        <v-btn
        color="blue-grey"
        class="white--text"
        @click="add()"
      >
        เพิ่มส่วนงาน
        <v-icon right dark>mdi-cloud-upload</v-icon>
      </v-btn>
      </v-col>
      <v-col cols="2">
        <v-btn
        color="red"
        class="white--text"
        @click="remove()"
      >
        ลบส่วนงาน
        <v-icon right dark>mdi-cloud-upload</v-icon>
      </v-btn>
      </v-col>
    </v-layout>
    <div class="form-group round1" v-for="(input,k) in inputs" :key="k" style="text-align: center; margin-top: 1%;">
    <v-layout class="row">
      <p style="margin-left: 2%;">ลำดับ {{k +1 }}</p>
    </v-layout>
    <v-layout class="row ml-10">
      <v-col cols="1">
        <p class="txt-font" style="margin-top: 1.5%;">ชื่อหัวข้อ</p>
      </v-col>
        <v-col cols="2" class="form-control">
          <v-text-field
            dense
            label="ชื่อเครือภาษไทย"
            outlined
          ></v-text-field>
      </v-col>
      <v-col cols="1">
        <p class="txt-font" style="margin-top: 1.5%;">ประเภท</p>
      </v-col>
        <v-col cols="2" class="form-control">
          <v-text-field
            dense
            label="ชื่อเครือภาษไทย"
            outlined
          ></v-text-field>
      </v-col>
      <v-col cols="2">
        <p class="txt-font" style="margin-top: 1.5%;">สายบังคับบัญชา</p>
      </v-col>
        <v-col cols="2" class="form-control">
          <v-text-field
            dense
            label="ชื่อเครือภาษไทย"
            outlined
          ></v-text-field>
      </v-col>
      <!-- <v-col cols="4" class="form-control">
          <v-text-field
            dense
            label="ชื่อเครือภาษาอังกฤษ"
            outlined
          ></v-text-field>
      </v-col> -->
      <v-layout class="column">
        <v-col cols="" class="form-control">
        <v-btn icon color="green" class="add_button">
          <v-icon @click="add(k)" v-show="k == inputs.length-1">mdi-plus</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="" class="form-control">
        <v-btn icon color="red" class="add_button">
          <v-icon @click="remove(k)" v-show="k || ( !k && inputs.length > 1)">mdi-delete</v-icon>
        </v-btn>
      </v-col>
      </v-layout>
      </v-layout>
  </div>
  <div class="text-right">
    <v-btn class="ma-2" tile color="red" dark>Cancle</v-btn>
    <v-btn class="ma-2" tile color="success" @click="submitData()">
      <v-icon left>mdi-pencil</v-icon> SAVE
    </v-btn>
  </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  name: 'overview',
  data () {
    return {
      inputs: [{
        name: '',
        party: ''
      }],
      tab: null,
      items: [
        'เครือ(กรุ๊ปบริษัท)', 'จัดการบริษัท'
      ]
    }
  },
  mounted () {
  },
  created () {
  },

  watched () {
  },
  methods: {
    submitData () {
      this.$router.push('/')
    },
    add () {
      this.inputs.push({
        name: '',
        party: ''
      })
      // console.log(this.inputs)
    },
    remove (index) {
      this.inputs.splice(index, 1)
    }
  }
}
</script>
<style scoped>
.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0 !important;
}
.v-input {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 14px;
}
.txt-font {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px;
}
.txt-head {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
}
.round1 {
  border: 1px solid rgb(165, 163, 163);
  border-radius: 5px;
}
</style>
